import * as angular from 'angular';

(function () {
    'use strict';
    angular.module('app').factory('TradeProposals', tradeProposalService);

    function tradeProposalService($resource, API_URL) {
        return $resource(
            API_URL.PROPOSAL,
            {
                id: '@id'
            },
            {
                get: {
                    url: API_URL.PROPOSAL + '/:id',
                    id: '@id',
                    method: 'GET'
                },
                save: { method: 'POST' },
                page: { method: 'GET' },
                delete: {
                    url: API_URL.PROPOSAL + '/:id',
                    id: '@id',
                    method: 'DELETE'
                },
                postRespond: {
                    url: API_URL.PROPOSAL + '/:id/response',
                    params: {
                        id: '@id'
                    },
                    method: 'POST'
                },
                rejectResponse: {
                    url: API_URL.PROPOSAL + '/:id/response/:responseId',
                    params: {
                        id: '@id',
                        responseId: '@responseId'
                    },
                    method: 'DELETE'
                },
                acceptRespond: {
                    url: API_URL.PROPOSAL + '/:id/response/:responseId/accept',
                    params: {
                        id: '@id',
                        responseId: '@responseId'
                    },
                    method: 'POST'
                },
                balancingCodes: {
                    url: API_URL.PROPOSAL + '/balancingCodes',
                    method: 'GET'
                },
                underlyingDeals: {
                    url: API_URL.PROPOSAL + '/underlyingDeals',
                    method: 'GET',
                    isArray: true
                },
                updateUnderlyingTariff: {
                    url: API_URL.PROPOSAL + '/updateUnderlyingTariff',
                    method: 'POST'
                },
                tsoConfig: {
                    url: API_URL.PROPOSAL + '/tsoConfig',
                    method: 'GET'
                },
                createProposal: {
                    method: 'POST'
                },
                editProposal: {
                    url: API_URL.PROPOSAL + '/:id',
                    method: 'PUT'
                },
                submitProposal: {
                    url: API_URL.PROPOSAL + '/:id/submit',
                    params: {
                        id: '@id'
                    },
                    method: 'POST'
                },
                removeTraderList: {
                    url: API_URL.PROPOSAL + '/:id/traderList',
                    params: {
                        id: '@id'
                    },
                    method: 'DELETE'
                },
                checkLeadTimes: {
                    url: API_URL.PROPOSAL + '/checkLeadTimes',
                    method: 'GET'
                },
                remitSupport: {
                    url: API_URL.SHIPPERS + '/channel-config',
                    method: 'GET'
                },
                acerSubmissions: {
                    url: API_URL.PROPOSAL + '/acer-submissions',
                    method: 'GET',
                    params: {
                        channelType: '@channelType',
                        proposalId: '@id'
                    },
                    isArray: true
                },
                proposalsTraderList: {
                    url: API_URL.PROPOSAL + '/proposals-trader-list',
                    method: 'GET',
                    isArray: true
                },
                responsesTraderList: {
                    url: API_URL.PROPOSAL + '/responses-trader-list',
                    method: 'GET',
                    isArray: true
                }
            }
        );
    }
})();
